<template>
  <div class="main">
    <FormWrapper :action="route('admin.settings.store')" method="POST">
      <div class="title-bar">
        <h1>Settings</h1>
        <AdminMenu class="pt-2" current="System" />
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div v-for="field in settingsFields" :key="field.name" class="col-12 mb-4"
              :class="{
                'd-none': field.name == 'legal-notice'
              }">
              <h4 class="text-primary text-uppercase mb-3">{{ field.label }}</h4>
              <HtmlField
                v-if="field.type == 'html'"
                :name="`settings[${field.name}]`"
                :help-text="field.helpText || ''"
                :value="field.value"
              />
              <Field
                v-else
                :type="field.type"
                :name="`settings[${field.name}]`"
                :help-text="field.helpText || ''"
                :value="field.value"
              />
              <hr class="mt-5" />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button type="submit" class="btn btn-success mr-2">Save Changes</button>
              <a class="btn btn-info" href="?discard=true">Discard Changes</a>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import AdminMenu from "../partials/AdminMenu";
export default {
  mixins: [DisplaysAlerts],
  components: { AdminMenu },
  props: {
    settings: { type: Object, required: true }
  },
  data() {
    return {
      settingsFields: [
        {
          type: "text",
          name: "roster-uploaded-email",
          label: "Roster Uploaded Email Recipient",
          value: null,
          helpText: "separate multiple email addresses with a comma"
        },
        {
          type: "text",
          name: "order-emails",
          label: "Order Related Email Notifications",
          value: null,
          helpText: "separate multiple email addresses with a comma"
        },
        {
          type: "text",
          name: "event-billing-report-email",
          label: "Event Billing Report Email Recipient",
          value: null,
          helpText: "separate multiple email addresses with a comma"
        },
        {
          type: "html",
          name: "account-created",
          label: "Account Creation Success Notice",
          value: null,
          helpText:
            "The information the user sees after successfully creating their account"
        },
        {
          type: "html",
          name: "legal-notice",
          label: "Legal Notice",
          value: null
        },
        {
          type: "html",
          name: "legal-disclaimer",
          label: "Legal Disclaimer",
          value: null,
          helpText:
            "All users are required to read and agree to the terms of the legal disclaimer before accessing the LMS. Use the HTML field above to edit the verbiage for the disclaimer."
        },
        {
          type: "html",
          name: "online-cancellation-policy",
          label: "Online Training Refund & Cancellation Policy",
          value: null,
          helpText:
            "Users will need to read and agree with the terms outlined below before purchasing online training. Use the HTML field above to edit the verbiage for the notice that will appear to users during the checkout process."
        }
      ]
    };
  },
  watch: {
    settings(val) {
      this.load();
    }
  },
  methods: {
    load() {
      this.settingsFields.map(field => {
        if (_.has(this.settings, field.name)) {
          field.value = this.settings[field.name];
        }
      });
    }
  },
  mounted() {
    this.load();
  }
};
</script>